import { render, staticRenderFns } from "./EditLibraryTask.vue?vue&type=template&id=2b076085"
import script from "./EditLibraryTask.vue?vue&type=script&lang=ts"
export * from "./EditLibraryTask.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports